import { Controller, ControllerProps, FieldValues } from 'react-hook-form';

import { NumberInput, type NumberInputProps } from './number-input';

export type NumberInputControllerProps<T extends FieldValues> = Required<Pick<ControllerProps<T>, 'control' | 'name'>> &
  Pick<NumberInputProps, 'label' | 'minValue' | 'maxValue' | 'id'>;

export const NumberInputController = <T extends FieldValues>({
  control,
  name,
  ...numberInputProps
}: NumberInputControllerProps<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field }) => <NumberInput value={field.value} onChange={field.onChange} {...numberInputProps} />}
  />
);
